import { useAuth } from '../context/AuthContext';
import { useEffect, useState } from 'react';
import { LogOut, User, Globe } from 'lucide-react';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

function UtcClock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  // Format: "Mon 20 · 14:53:12 UTC"
  const weekday = now.toLocaleDateString('en-US', { weekday: 'short', timeZone: 'UTC' });
  const day = now.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', timeZone: 'UTC' });
  const time = now.toLocaleTimeString('en-GB', { hour12: false, timeZone: 'UTC' });
  return (
    <div
      className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-md border border-zinc-800 bg-zinc-950"
      data-testid="utc-clock"
      title="All times in the tool are UTC+0. This is the reference clock."
    >
      <Globe className="w-3.5 h-3.5 text-emerald-400" strokeWidth={1.5} />
      <div className="flex flex-col leading-tight">
        <span className="text-[9px] uppercase tracking-wider text-zinc-500">Tool time · UTC</span>
        <span className="text-sm font-mono text-white">
          {weekday} {day} · {time}
        </span>
      </div>
    </div>
  );
}

export default function Header() {
  const { user, logout } = useAuth();

  return (
    <header className="bg-background/80 backdrop-blur-lg border-b border-white/5 px-4 md:px-8 py-4">
      <div className="flex items-center justify-between gap-3">
        <div className="flex-1 flex items-center">
          <UtcClock />
        </div>
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="gap-2 text-white hover:bg-white hover:text-black transition-colors" data-testid="user-menu-trigger">
              <div className="w-8 h-8 rounded-full bg-zinc-800 flex items-center justify-center border border-zinc-700">
                <User className="w-4 h-4" />
              </div>
              <div className="hidden md:flex flex-col items-start">
                <span className="text-sm font-semibold">{user?.name}</span>
                <span className="text-xs text-muted-foreground uppercase">{user?.va_role || user?.role}</span>
              </div>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56 bg-zinc-900 border-zinc-800">
            <DropdownMenuLabel className="text-white">
              <div>{user?.name}</div>
              <div className="text-xs text-muted-foreground font-normal">{user?.email}</div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator className="bg-zinc-800" />
            <DropdownMenuItem 
              onClick={logout} 
              className="text-red-500 focus:text-red-500 focus:bg-red-900/20 cursor-pointer"
              data-testid="logout-button"
            >
              <LogOut className="mr-2 h-4 w-4" />
              <span>Logout</span>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}